import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';





@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private _authService: AuthService, private _router: Router) {

  }

  canActivate(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._authService.isActive().subscribe(response => {
        if (response) {
          resolve(true);
        }
      })
    });


  }


}
